'use client'

import { useRouter as usePagesRouter } from 'next/router'
import {
  useRouter as useAppRouter,
  usePathname,
  useSearchParams,
  useParams,
} from 'next/navigation'

export function useRouter() {
  // Detect if we're in the App Router environment (naively)
  const isAppRouter = typeof useAppRouter === 'function'

  if (isAppRouter) {
    const router = useAppRouter()
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const params = useParams()

    return {
      pathname,
      query: Object.fromEntries(searchParams.entries()),
      params,
      push: router.push,
      replace: router.replace,
      back: router.back,
    }
  } else {
    const router = usePagesRouter()
    return {
      pathname: router.pathname,
      query: router.query,
      params: router.query, // In Pages Router, dynamic params come through query
      push: router.push,
      replace: router.replace,
      back: router.back,
    }
  }
}